import React, { useState } from 'react';
import * as Icons from 'lucide-react';
import { Tour } from '../../types/tours';

interface TourDetailTabsProps {
  tour: Tour;
}

type Tab = 'includes' | 'bring';

const TourDetailTabs: React.FC<TourDetailTabsProps> = ({ tour }) => {
  const [activeTab, setActiveTab] = useState<Tab>('includes');

  const includeItems = tour.tour_shared_items
    ?.filter(item => item.shared_items.type === 'include')
    .sort((a, b) => a.display_order - b.display_order) || [];

  const bringItems = tour.tour_shared_items
    ?.filter(item => item.shared_items.type === 'bring')
    .sort((a, b) => a.display_order - b.display_order) || [];

  return (
    <div>
      <div className="border-b border-[#2A382A]/10 mb-8">
        <div className="flex gap-8">
          <button
            onClick={() => setActiveTab('includes')}
            className={`relative py-4 text-lg font-medium transition-colors ${
              activeTab === 'includes'
                ? 'text-[#2A382A]'
                : 'text-[#2A382A]/60 hover:text-[#2A382A]'
            }`}
          >
            <span className="block">What's Included</span>
            {activeTab === 'includes' && (
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#2A382A]" />
            )}
          </button>
          <button
            onClick={() => setActiveTab('bring')}
            className={`relative py-4 text-lg font-medium transition-colors ${
              activeTab === 'bring'
                ? 'text-[#2A382A]'
                : 'text-[#2A382A]/60 hover:text-[#2A382A]'
            }`}
          >
            <span className="block">What to Bring</span>
            {activeTab === 'bring' && (
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#2A382A]" />
            )}
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="bg-white rounded-xl p-8 min-h-[300px]">
        {activeTab === 'includes' ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {includeItems.map(item => (
              <div key={item.id} className="flex items-start gap-4">
                <div className="p-2 bg-[#2A382A]/5 rounded-lg">
                  {React.createElement(
                    Icons[item.shared_items.icon as keyof typeof Icons],
                    { className: 'w-5 h-5 text-[#2A382A]' }
                  )}
                </div>
                <div>
                  <h3 className="font-medium text-[#2A382A] mb-1">
                    {item.shared_items.title}
                  </h3>
                  <p className="text-sm text-[#2A382A]/70">
                    {item.shared_items.description}
                  </p>
                </div>
              </div>
            ))}
            {includeItems.length === 0 && (
              <p className="text-[#2A382A]/60 col-span-2 text-center py-8">
                No items listed
              </p>
            )}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {bringItems.map(item => (
              <div key={item.id} className="flex items-start gap-4">
                <div className="p-2 bg-[#2A382A]/5 rounded-lg">
                  {React.createElement(
                    Icons[item.shared_items.icon as keyof typeof Icons],
                    { className: 'w-5 h-5 text-[#2A382A]' }
                  )}
                </div>
                <div>
                  <h3 className="font-medium text-[#2A382A] mb-1">
                    {item.shared_items.title}
                  </h3>
                  <p className="text-sm text-[#2A382A]/70">
                    {item.shared_items.description}
                  </p>
                </div>
              </div>
            ))}
            {bringItems.length === 0 && (
              <p className="text-[#2A382A]/60 col-span-2 text-center py-8">
                No items listed
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TourDetailTabs;